import React from "react";

const ReviewCard = ({ data }) => {
  return (
    <>
      <div class="testimonial-single bg-white border-radius">
        <div class="testimonial-content">
          <div class="testimonial-author-img">
            <img src={data.img || `/assets/img/testimonial/01.jpg`} className="review-img" alt="" />
          </div>
          <div class="testimonial-author-info">
            <h4>{data.name}</h4>
            <p>{data.country}</p>
          </div>
        </div>
        <div class="testimonial-quote">
          <span class="testimonial-quote-icon">
            <i class="flaticon-quote"></i>
          </span>
          <p>
            {data.review}
          </p>
        </div>
        <div>{data.vehicle}</div>
        <div class="testimonial-rate">
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
        </div>
      </div>
    </>
  );
};

export default ReviewCard;
